import styled, { css } from 'styled-components'

import { applyIPadOnlyStyle } from 'helpers/css'
import { isMobileOrIPad } from 'utils/device'

export const LoginContainer = styled.div`
    width: 70%;
    height: min-content;
    min-height: 35vh;
    background-color: white;
    border-radius: 16px;
    box-sizing: initial;
    padding: 2rem;
    box-shadow: -16px -16px 40px rgba(253, 255, 255, 0.8),
        16px 16px 40px rgba(187, 195, 206, 0.6);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    ${applyIPadOnlyStyle(
        `
        width: 100vw,
        padding: 0,
        flex-direction: column,
        box-shadow: none,
        height: 100%,
        justify-content: flex-end,
        background-size: contain, contain,
        background-color: transparent,
     `,
        {
            min: 0,
            max: 1370,
            orientation: 'both',
            shouldApplyStyle: isMobileOrIPad,
        }
    )}

    ${() =>
        isMobileOrIPad &&
        css`
            @media (min-width: 0px) and (max-width: 1370px) and (-webkit-min-device-pixel-ratio: 2) {
                background: url('/assets/auth-bg-phone.svg') top center
                        no-repeat,
                    url('/assets/auth-bg-phone-bottom.svg') bottom center
                        no-repeat;
                background-size: contain, contain;
            }
        `}

        ${applyIPadOnlyStyle(
            `
    transform: rotate(-90deg);
    transform-origin: left top;
    /* Set content width to viewport height */
    width: 100vh;
    /* Set content height to viewport width */
    height: 100vw;
    overflow-x: hidden;
    position: absolute;
    top: 100%;
    left: 0;
     `,
            {
                min: 0,
                max: 1370,
                orientation: 'landscape',
                shouldApplyStyle: isMobileOrIPad,
            }
        )}
`

export const ImageContainer = styled.div`
    flex: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    ${applyIPadOnlyStyle(
        `
    justify-content: flex-end;
     `,
        {
            min: 0,
            max: 1370,
            orientation: 'both',
            shouldApplyStyle: isMobileOrIPad,
        }
    )}
`

export const Image = styled.img`
    width: 90%;
    height: auto;

    ${applyIPadOnlyStyle(
        `
        width: 60%
     `,
        {
            min: 0,
            max: 1370,
            orientation: 'both',
            shouldApplyStyle: isMobileOrIPad,
        }
    )}
`

export const FormContainer = styled.div`
    flex: 2;
    padding: 0 5%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    ${applyIPadOnlyStyle(
        `
    flex: 3;
    padding: 0 10%;
     `,
        {
            min: 0,
            max: 1370,
            orientation: 'both',
            shouldApplyStyle: isMobileOrIPad,
        }
    )}

    @media (max-width: 700px) {
        padding: 10%;
    }
`

export const TermsAndPrivacyPolicy = styled.p`
    color: #828282;
    font-size: 0.8rem;
    margin-left: -4px;
`

export const PolicyLink = styled.a`
    margin: 0 4px;
    color: #828282;
    font-weight: bold;
    text-decoration: none;
`

export const ContactUs = styled.div`
    position: fixed;
    right: 2vw;
    bottom: 2vw;
    height: 5vw;
    width: 5vw;
    background: url('/assets/contact-us.svg') center no-repeat;
    background-size: contain;

    @media (max-width: 700px) {
        height: 10vw;
        width: 10vw;
    }
`
